/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailTemplateLanguage } from './MailTemplateLanguage';
import {
    MailTemplateLanguageFromJSON,
    MailTemplateLanguageFromJSONTyped,
    MailTemplateLanguageToJSON,
    MailTemplateLanguageToJSONTyped,
} from './MailTemplateLanguage';

/**
 * 
 * @export
 * @interface MailboxTemplateContentDTO
 */
export interface MailboxTemplateContentDTO {
    /**
     * 
     * @type {MailTemplateLanguage}
     * @memberof MailboxTemplateContentDTO
     */
    Language?: MailTemplateLanguage;
    /**
     * 
     * @type {string}
     * @memberof MailboxTemplateContentDTO
     */
    Subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxTemplateContentDTO
     */
    Body?: string | null;
}



/**
 * Check if a given object implements the MailboxTemplateContentDTO interface.
 */
export function instanceOfMailboxTemplateContentDTO(value: object): value is MailboxTemplateContentDTO {
    return true;
}

export function MailboxTemplateContentDTOFromJSON(json: any): MailboxTemplateContentDTO {
    return MailboxTemplateContentDTOFromJSONTyped(json, false);
}

export function MailboxTemplateContentDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxTemplateContentDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Language': json['Language'] == null ? undefined : MailTemplateLanguageFromJSON(json['Language']),
        'Subject': json['Subject'] == null ? undefined : json['Subject'],
        'Body': json['Body'] == null ? undefined : json['Body'],
    };
}

export function MailboxTemplateContentDTOToJSON(json: any): MailboxTemplateContentDTO {
    return MailboxTemplateContentDTOToJSONTyped(json, false);
}

export function MailboxTemplateContentDTOToJSONTyped(value?: MailboxTemplateContentDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Language': MailTemplateLanguageToJSON(value['Language']),
        'Subject': value['Subject'],
        'Body': value['Body'],
    };
}

